import axios from "axios"
import { BotConfig } from "./botConfig"
import { UserManager } from "./userManager"

const AUTH_FAILED_MESSAGE =
  "Вы не прошли авторизацию. Попробуйте в боте заново зайти на веб-сайт."

const NO_BOT_ID_MESSAGE =
  "Не указан bot_id. Убедитесь, что приложение запущено через Telegram Mini App."

const NO_TELEGRAM_MESSAGE = AUTH_FAILED_MESSAGE

const NETWORK_ERROR_MESSAGE = "Ошибка сети при авторизации. Попробуйте позже."

export class AuthManager {
  static async validate() {
    const botId = BotConfig.getBotId()
    if (!botId) {
      return { success: false, error: NO_BOT_ID_MESSAGE }
    }

    const tg = window.Telegram?.WebApp
    if (!tg?.initData) {
      return { success: false, error: NO_TELEGRAM_MESSAGE }
    }

    const telegramUser = UserManager.getTelegramUserData()
    if (!telegramUser?.id) {
      return { success: false, error: NO_TELEGRAM_MESSAGE }
    }

    try {
      const response = await axios.get(
        `${window.location.origin}/user/balance/${botId}/${telegramUser.id}`
      )
      return {
        success: true,
        user: telegramUser,
        botId,
        balanceData: response.data,
      }
    } catch (error) {
      const status = error?.response?.status
      if (status === 401 || status === 403 || status === 404) {
        return { success: false, error: AUTH_FAILED_MESSAGE }
      }
      return { success: false, error: NETWORK_ERROR_MESSAGE }
    }
  }
}
